import { S } from 'core/helpers'

const combine = (...list: Array<string | null | undefined>) => S.join(list, '.')

export { combine }
